var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ns-searchbar-list", class: [_vm.typeClass] },
    [
      _vm.type === "popular"
        ? _c("p", { staticClass: "title-text" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "search-list",
          attrs: { id: _vm.type + "-search-items" }
        },
        [
          _vm.type === "recent"
            ? _c(
                "li",
                {
                  staticClass: "clear-recent-searches",
                  on: {
                    click: function($event) {
                      return _vm.$emit("clear-recent-searches")
                    }
                  }
                },
                [
                  _c("p", { staticClass: "title-text recent" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.searchData, function(item) {
            return _c(
              "li",
              {
                key: item.sku || item.itemName,
                staticClass: "list-item",
                class: {
                  "show-pricing":
                    _vm.type === "predictive" && _vm.showPricingInPredictive
                },
                attrs: { "data-search-type": _vm.type, title: item.itemName },
                on: {
                  click: function($event) {
                    return _vm.$emit("click-search-item", item, _vm.type)
                  },
                  mouseover: function($event) {
                    return _vm.$emit("toggle-value", $event)
                  },
                  mouseout: function($event) {
                    return _vm.$emit("toggle-value", $event)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "image-block",
                    class: { "two-line": _vm.showPricingInPredictive }
                  },
                  [
                    _c("img", {
                      class: { "error-loading": !item.img },
                      attrs: { src: item.img + ".64.64.png", alt: "Product" },
                      on: { error: _vm.imgError, load: _vm.imgLoad }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "missing-image" },
                      [
                        _c("NsIcon", {
                          staticClass: "missing-icon",
                          attrs: {
                            "icon-name": "icon-product-placeholder-24",
                            size: "custom"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showPricingInPredictive
                  ? _c("div", { staticClass: "list-two-line-row" }, [
                      _c("div", { staticClass: "list-row" }, [
                        _c(
                          "div",
                          { staticClass: "item-description" },
                          [
                            _c(
                              "VClamp",
                              { attrs: { autoresize: "", "max-lines": 1 } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.itemName) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-row" }, [
                        _c("div", {
                          staticClass: "item-sku",
                          domProps: { innerHTML: _vm._s(_vm.displaySku(item)) }
                        }),
                        _vm._v(" "),
                        _vm.pricesLoading
                          ? _c("div", [
                              _c("img", {
                                staticClass: "loading-spinner",
                                attrs: {
                                  src:
                                    "https://www.nuskin.com/content/dam/apps/checkout/icon-spinner.gif",
                                  alt: "Loading"
                                }
                              })
                            ])
                          : _c("div", { staticClass: "item-pricing" }, [
                              _vm.showPVInPricing()
                                ? _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.formatPV(item.pv))
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [_vm._v("• ")]),
                              _vm._v(" "),
                              item.originalPrice &&
                              item.originalPrice > item.price
                                ? _c(
                                    "span",
                                    { staticClass: "item-linethrough" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatPrice(item.originalPrice)
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "item-bold" }, [
                                _vm._v(_vm._s(_vm.formatPrice(item.price)))
                              ])
                            ])
                      ])
                    ])
                  : _c(
                      "div",
                      { staticClass: "item-description" },
                      [
                        _c(
                          "VClamp",
                          { attrs: { autoresize: "", "max-lines": 2 } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(item.itemName) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.showAddToCart(item)
                  ? _c(
                      "div",
                      {
                        staticClass: "add-to-cart-button",
                        class: { "two-line": _vm.showPricingInPredictive },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$emit("add-to-cart", $event, item)
                          }
                        }
                      },
                      [
                        _c("NsIcon", {
                          staticClass: "add-to-cart-icon",
                          attrs: {
                            "icon-name": _vm.isExclusiveOffer(item)
                              ? "icon-exclusive-offer"
                              : "icon-smallcart-add"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.showMoreButton && !_vm.hideSeeMoreResults
            ? _c(
                "li",
                {
                  staticClass: "see-more-results",
                  on: {
                    click: function($event) {
                      return _vm.$emit("see-more-results")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.translations.seeMoreResults) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }